export default {
  login: "Dakshbarad",
  id: 35626597,
  node_id: "MDQ6VXNlcjM1NjI2NTk3",
  avatar_url: "https://avatars3.githubusercontent.com/u/35626597?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/Dakshbarad",
  html_url: "https://github.com/Dakshbarad",
  followers_url: "https://api.github.com/users/Dakshbarad/followers",
  following_url:
    "https://api.github.com/users/Dakshbarad/following{/other_user}",
  gists_url: "https://api.github.com/users/Dakshbarad/gists{/gist_id}",
  starred_url: "https://api.github.com/users/Dakshbarad/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/Dakshbarad/subscriptions",
  organizations_url: "https://api.github.com/users/Dakshbarad/orgs",
  repos_url: "https://api.github.com/users/Dakshbarad/repos",
  events_url: "https://api.github.com/users/Dakshbarad/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/Dakshbarad/received_events",
  type: "User",
  site_admin: false,
  name: "Daksh Barad",
  company: "Daxus",
  blog: "",
  location: "Ahmedabad",
  email: null,
  hireable: null,
  bio: "Full Stack Web Developer",
  twitter_username: null,
  public_repos: 2,
  public_gists: 0,
  followers: 1,
  following: 4,
  created_at: "2018-01-20T10:46:13Z",
  updated_at: "2021-01-11T16:53:19Z",
};
